import { render } from "./UserRegistration.vue?vue&type=template&id=3ae56284&scoped=true&ts=true"
import script from "./UserRegistration.vue?vue&type=script&lang=ts"
export * from "./UserRegistration.vue?vue&type=script&lang=ts"

import "./UserRegistration.vue?vue&type=style&index=0&id=3ae56284&lang=scss&scoped=true"

import exportComponent from "/home/klaus/Dokumente/Projekte/Hochzeit/wedding-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae56284"]])

export default __exports__